import { render, staticRenderFns } from "./skuPrice.vue?vue&type=template&id=c4f8f8dc&"
import script from "./skuPrice.vue?vue&type=script&lang=js&"
export * from "./skuPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports